export var DEFAULT_SIZE = 40;
export var DEFAULT_COLOR = '#333';
//# sourceMappingURL=types.js.map